<script lang="ts" setup>
import type { ITableColumnsOptions } from '@modules/tables/types';
import VIconButton from '@components/buttons/VIconButton/VIconButton.vue';
import VCard from '@components/card/VCard/VCard.vue';
import VDownloadReportButton
  from '@modules/download-report/components/VDownloadReportButton/VDownloadReportButton.vue';
import { useDownloadReport } from '@modules/download-report/composables';
import {
  PLAYERS_PERMISSIONS,
  TRANSLATION_ADMIN_PLAYERS,
} from '@modules/players/constants';
import { useDownloadPlayersReportMutation } from '@modules/players/mutations';
import { usePlayersListQuery } from '@modules/players/queries';
import { ADMIN_PLAYER_PROFILE_ROUTE_NAME } from '@modules/players/submodules/PlayerProfile/constants';
import VTable from '@modules/tables/components/VTable/VTable.vue';
import { useTableData } from '@modules/tables/composables';

const {
  tableState,
  isLoading,
  isFetching,
  data,
  updateTableState,
  refreshTableData,
} = useTableData(usePlayersListQuery);

const columnOptions: ITableColumnsOptions = {
  cid: {
    defaultMobilePreview: true,
  },
};

const {
  isReportLoading,
  onDownloadReport,
} = useDownloadReport(useDownloadPlayersReportMutation(), tableState);
</script>

<template>
  <VCard v-data-qa-auto-id="'PlayersListPage'" type="table">
    <VTable
      :data="data"
      :state="tableState"
      :loading="isLoading"
      :is-fetching="isFetching"
      :title-t-path="$getTPath(TRANSLATION_ADMIN_PLAYERS, 'PLAYER_LIST_HEADER')"
      :columns-options="columnOptions"
      @state-update="updateTableState"
      @refresh="refreshTableData"
    >
      <template #recordAction="{ listItem }">
        <VIconButton
          icon="pi-file-edit"
          :to="{ name: ADMIN_PLAYER_PROFILE_ROUTE_NAME, params: { id: listItem.cid } }"
        />
      </template>
      <template
        v-if="$hasPermission(PLAYERS_PERMISSIONS.DOWNLOAD_PLAYERS_LIST)"
        #footerButtons
      >
        <VDownloadReportButton
          :label="$getTranslation(TRANSLATION_ADMIN_PLAYERS, 'DOWNLOAD_REPORT')"
          :loading="isReportLoading"
          @download="onDownloadReport"
        />
      </template>
    </VTable>

    <RouterView />
  </VCard>
</template>
